// A440 Equal Temperament reference frequencies for 88-key piano
// Key 1 = A0 (27.5 Hz), Key 49 = A4 (440 Hz), Key 88 = C8 (4186 Hz)
// Formula: f(n) = 440 × 2^((n - 49) / 12)

export const TOTAL_KEYS = 88;

export const NOTE_NAMES = [
  'A',
  'A#',
  'B',
  'C',
  'C#',
  'D',
  'D#',
  'E',
  'F',
  'F#',
  'G',
  'G#',
];

/** Get the note name and octave for a given key number (1-88) */
export function getNoteName(keyNum: number): string {
  // Key 1 = A0, Key 4 = C1, Key 16 = C2, etc.
  const semitoneIndex = keyNum - 1; // 0-based
  const noteName = NOTE_NAMES[semitoneIndex % 12];
  // A0 is key 1. Octave changes at C.
  // Key 1 (A0): semitone 0 → note A, octave 0
  // Key 4 (C1): semitone 3 → note C, octave 1
  const octave = Math.floor((semitoneIndex + 9) / 12);
  return `${noteName}${octave}`;
}

/** Get the expected A440 frequency for a key number (1-88) */
export function getExpectedFrequency(keyNum: number): number {
  return 440 * 2 ** ((keyNum - 49) / 12);
}

/** Pre-computed frequency table */
export const FREQUENCIES: number[] = [];
for (let i = 1; i <= TOTAL_KEYS; i++) {
  FREQUENCIES.push(getExpectedFrequency(i));
}

/** Detect a new key when pitch changes by more than this ratio (~1 semitone = 2^(1/12) ≈ 1.0595) */
export const SEMITONE_RATIO = 2 ** (1 / 12);

/** Minimum pitch change ratio to trigger transition (slightly less than 1 semitone for tolerance) */
export const PITCH_CHANGE_THRESHOLD = 0.04; // ~4% frequency change (about 0.7 semitones)

/** Time in ms that a new pitch must remain stable before registering */
export const STABILIZATION_MS = 150;

/** Minimum RMS amplitude to consider as a real note (vs silence/noise) */
export const AMPLITUDE_THRESHOLD = 0.01;

/** Sample rate for audio processing */
export const SAMPLE_RATE = 44100;

/** FFT size for analysis */
export const FFT_SIZE = 8192;

/** Tuning tolerance in cents — keys within this range are "in tune" */
export const IN_TUNE_CENTS = 10;

/** Slightly off threshold in cents */
export const SLIGHT_OFF_CENTS = 25;

/** Milestone interval (every N keys, show encouragement) */
export const MILESTONE_INTERVAL = 12;

export const MILESTONE_MESSAGES = [
  'Great start! Keep going! 🎹',
  "You're cruising! 🎵",
  'Sounding good! Keep it up! ✨',
  'Halfway mark is close! 🎶',
  'Over the hill! Downhill from here! 🏔️',
  "You're a pro at this! 💪",
  'Almost there! Final stretch! 🏁',
  'So close! Just a bit more! 🎯',
];
